import React from 'react';
import PropTypes from 'prop-types';
import { PasswordForgetForm } from './PasswordForget';
import PasswordChangeForm from './PasswordChange';
import UserDetailsForm from './UserDetails';
import UserFavorites from "./UserFavorites";
import UserDecks from "./UserDecks";

const loginStyle = {
  marginTop: 50,
  backgroundColor: "white"
};
const h2Style = {
  paddingLeft: 10,
  marginTop: 10,
  fontFamily: "Audiowide, cursive",
  color: "cadetblue"
};

const UserHome = (props, { authUser, userName, authUserId, authEmail, inGameName, displayIGN, favorites, ethWallet }) =>
  <div style={loginStyle}  className="Site_Content, container">
  <h2 style={h2Style}>User Details</h2>
    <UserDetailsForm userId={authUserId} authEmail={authEmail} userName={userName} inGameName={inGameName} displayIGN={displayIGN} ethWallet={ethWallet} />
    <hr />
    <PasswordChangeForm />
    <hr />
  <h2 style={h2Style}>Favorite Decks</h2>
    <UserFavorites favorites={favorites} />
  <h2 style={h2Style}>My Decks</h2>
    <UserDecks user={userName} />
  </div>

UserHome.contextTypes = {
  authUser: PropTypes.object,
  userName: PropTypes.string,
  authUserId: PropTypes.string,
  authEmail: PropTypes.string,
  inGameName: PropTypes.string,
  displayIGN: PropTypes.bool,
  favorites: PropTypes.array,
  ethWallet: PropTypes.string
};

export default UserHome;



// WEBPACK FOOTER //
// ./src/Authentication/UserHome.js